// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1M02-","image":"Header_image__2_KFV","name":"Header_name__2zsja","info":"Header_info__1Utyx","infoRow":"Header_infoRow__1XjsZ"};